import { gql, MutationHookOptions, useMutation } from '@apollo/client';

import {
  UpdateTenantDisplayNameMutation,
  UpdateTenantDisplayNameMutationVariables,
} from '../../../shared/generated/graphql';

export const UPDATE_TENANT_DISPLAY_NAME = gql`
  mutation updateTenantDisplayName($name: String!) {
    updateTenantDisplayName(name: $name) {
      display_name
      updated_by
      updated_on
    }
  }
`;

export const useUpdateTenantDisplayName = (
  options: MutationHookOptions<
    UpdateTenantDisplayNameMutation,
    UpdateTenantDisplayNameMutationVariables
  >,
) =>
  useMutation<
    UpdateTenantDisplayNameMutation,
    UpdateTenantDisplayNameMutationVariables
  >(UPDATE_TENANT_DISPLAY_NAME, options);
